import type { FC, ReactNode } from "react";
import { Flex, Spacing, Text } from "@huub-web/ui";

import {
  contentColumnStyle,
  descriptionStyle,
  imageStyle,
  maskedPanelStyle,
  titleStyle,
  wrapperStyle,
} from "./VerenigingEigenHuisMaskedBanner.css";

type VerenigingEigenHuisMaskedBannerProps = {
  children?: ReactNode;
  /**
   * Banner title displayed in the left panel
   */
  title: string;
  /**
   * Banner description displayed below the title
   */
  description: string;
  /**
   * URL of the image to display in the masked right panel
   */
  imageSrc: string;
};

/**
 * Reusable two-column masked banner for VEH theme slot overrides.
 * Left: primary-coloured content panel with a curved right edge.
 * Right: masked image panel (hidden on mobile).
 */
export const VerenigingEigenHuisMaskedBanner: FC<
  VerenigingEigenHuisMaskedBannerProps
> = ({ children, title, description, imageSrc }) => {
  return (
    <>
      <Spacing height="m" />
      <Flex direction="column" className={wrapperStyle}>
        <Flex direction="column" gap="m" className={contentColumnStyle}>
          <Text variant="displayM" bold className={titleStyle}>
            {title}
          </Text>
          <Text
            variant="bodyM"
            color="currentColor75"
            className={descriptionStyle}
          >
            {description}
          </Text>
          {children}
        </Flex>
        <div className={maskedPanelStyle}>
          <img className={imageStyle} src={imageSrc} alt="" loading="eager" />
        </div>
      </Flex>
    </>
  );
};
